export class Period {

  private readonly PRE_FIX: string = 'P';
  amount: number;
  postFix: PeriodPostFix;

  constructor(amount: number, postFix: PeriodPostFix) {
    this.amount = amount;
    this.postFix = postFix;
  }

  static parse(input: string): Period {
    const amount: number = parseInt(input.substring(1, input.length - 1), 10);
    const postFix: PeriodPostFix = PeriodPostFix[input.slice(-1)];
    return new Period(amount, postFix);
  }

  output(): string {
    return this.PRE_FIX + this.amount + PeriodPostFix[this.postFix];
  }
}

export enum PeriodPostFix {
  D,
  W,
  M,
  Y,
}
